import React from 'react';
import { Layout, Card, Typography } from 'antd';
import { useAuth } from '../context/AuthContext';
import NavigationBar from '../components/NavigationBar';

const { Content } = Layout;
const { Title, Text } = Typography;

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <>
      <NavigationBar />
      <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
        <Content style={{ padding: '24px' }}>
          {/* Welcome Message */}
          <Card style={{ marginBottom: '24px', textAlign: 'center', background: 'rgba(255, 255, 255, 0.95)', position: 'relative', zIndex: 10 }}>
            <Title level={2}>Welcome to the Portal</Title>
            <Text>Hello, {user?.firstName || user?.first_name || ''} {user?.lastName || user?.last_name || ''}!</Text>
            <br />
            <Text type="secondary">Please use the navigation bar to access the different sections of the portal.</Text>
          </Card>
        </Content>
      </Layout>
    </>
  );
};

export default Dashboard;